import React from 'react';
import { CardIconProps } from './types';

function EloIcon({ size = '2em' }: CardIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 300 300">
      <g fill="none" fillRule="evenodd">
        <path
          d="M150.086.257C232.866.257 300 67.2 300 149.743c0 82.543-67.135 149.486-149.914 149.486-82.78 0-149.914-66.943-149.914-149.486C.258 67.114 67.307.257 150.086.257z"
          stroke="#231F20"
          strokeWidth={0.567}
          fill="#050013"
        />
        <path
          d="M85.702 109.629c21.748 0 39.885 15 44.785 35.142l-18.567 8.058-18.997 8.314-45.56 19.886c-4.899-7.286-7.735-16.029-7.735-25.458 0-25.371 20.63-45.942 46.074-45.942zm19.77 28.542l-45.988 19.8c-.086-.771-.086-1.628-.086-2.4 0-14.485 11.777-26.314 26.39-26.314 7.822 0 14.871 3.514 19.685 8.914zM117.937 188.4c-16.504 15.6-38.338 17.143-57.507 5.571l10.83-16.457c10.918 6.515 21.835 5.486 32.837-3.171l13.84 14.057zM136.676 177.086l-.086-86.829h16.419v84.514c0 .772.086 1.543 1.203 1.972l14.355 5.571-6.447 16.8L145.272 192c-6.36-2.829-8.596-6.686-8.596-14.914z"
          fill="#FFF"
        />
        <path
          d="M198.825 175.629c-6.189-4.8-10.143-12.258-10.143-20.658 0-7.457 3.18-14.228 8.166-19.028l-10.659-17.229c-10.745 8.486-17.622 21.515-17.622 36.257 0 15.858 7.995 29.829 20.2 38.143l10.058-17.485z"
          fill="#009DD7"
        />
        <path
          d="M206.046 130.2c2.75-1.029 5.76-1.543 8.854-1.543 11.26 0 20.888 7.029 24.584 16.972l20.459-1.715c-4.9-20.228-23.21-35.228-45.043-35.228-6.19 0-12.035 1.2-17.45 3.428l8.596 18.086z"
          fill="#FFF200"
        />
        <path
          d="M241.203 156.171c-.687 13.886-12.206 24.943-26.217 24.943-2.235 0-4.384-.257-6.361-.771l-7.995 18.514c4.556 1.457 9.37 2.314 14.442 2.314 24.928 0 45.3-19.714 46.332-44.314l-20.2-.686z"
          fill="#E33206"
        />
      </g>
    </svg>
  );
}

export default EloIcon;
